import { Button } from "@similarweb/ui-components";

import { TitleWithInfo } from "app/components/TitleWithInfo/TitleWithInfo";
import { translate } from "app/filters/i18nFilter";

import { StyledHeader } from "./styles";

type HeaderSchema = {
    tooltip: string;
    isLoading: boolean;
    onOpenModal?: () => void;
};

export const Header = ({ tooltip, onOpenModal, isLoading }: HeaderSchema) => {
    return (
        <StyledHeader>
            <TitleWithInfo
                title={translate("bt.metrics.monthlyVisits.competitorShare.title")}
                tooltip={translate(tooltip)}
            />

            <Button
                type="flat"
                onClick={onOpenModal}
                isDisabled={isLoading}
                dataAutomation="bt-competitor-traffic-share-cta"
            >
                {translate("bt.report.metric.btn.see_all_competitors.text")}
            </Button>
        </StyledHeader>
    );
};
